import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loadingSgnl = signal(false);

  constructor() { }

  get loadingSgnl() {
    return this._loadingSgnl;
  }

  setLoading(loading: boolean) {
    this._loadingSgnl.set(loading);
  }
}
